<template>
  <div id="perception">
    <div class="topPart">
      <div class="titlePart">
        <h2 class="title">独立感知</h2>
      </div>
      <el-row class="elRow">
        <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12" align="center">
          <img
            src="../../../assets/img/product/ganzhi.png"
            alt=""
            class="leftImg"
          />
        </el-col>
        <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12" align="center">
          <div class="rightInfo wow fadeInUp">
            <div class="rightTitle">
              对于未安装消防报警系统、或联网布线具有较大难度的建筑单位，可以采用无线监控方案。包含烟感、温感、手报、声光、可燃气体等多种消防报警设备，灵活适应多种应用场景。
            </div>
            <div class="rightItem">
              <img
                src="../../../assets/img/about/dh.png"
                alt=""
                class="itemImg"
              />
              <div class="itemTxt">无需安装消防报警主机;</div>
            </div>
            <div class="rightItem">
              <img
                src="../../../assets/img/about/dh.png"
                alt=""
                class="itemImg"
              />
              <div class="itemTxt">设备无需布线,直接安装即可使用;</div>
            </div>
            <div class="rightItem">
              <img
                src="../../../assets/img/about/dh.png"
                alt=""
                class="itemImg"
              />
              <div class="itemTxt">
                采用NB-IOT通信方式,功耗低、覆盖范围广;
              </div>
            </div>
            <div class="rightItem">
              <img
                src="../../../assets/img/about/dh.png"
                alt=""
                class="itemImg"
              />
              <div class="itemTxt">内置大功率电池,可续航2-3年;</div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="lastPart">
      <div class="title2">应用场景</div>
      <div class="imgBox">
        <Viewer :srcArr="srcListArr" />
      </div>
    </div>
  </div>
</template>

<script>
import { WOW } from "wowjs";
import Viewer from "../../../components/viewer/viewer.vue";
export default {
  props: {},
  data() {
    return {
      dialogVisible: false,
      activeName: "1",
      srcListArr: [
        {
          src: require("../../../assets/img/product/dlgz.png"),
        },
        {
          src: require("../../../assets/img/product/lishishuju2.png"),
        },
      ],
    };
  },
  computed: {},
  created() {},
  mounted() {
    new WOW({ live: false }).init();
  },
  watch: {},
  methods: {
    showModel() {
      this.dialogVisible = true;
    },
  },
  components: {
    Viewer,
  },
};
</script>

<style scoped lang="scss">
#perception {
  .topPart {
    background-position: center;
    background-size: 100% 100%;
    background-image: url("../../../assets/img/product/ganzhibg.png");
    min-height: 60rem;
    background-repeat: no-repeat;

    .titlePart {
      text-align: center;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      margin: 4rem;
      padding: 0 14%;
    }
    .elRow {
      display: flex;
      flex-wrap: wrap;
      padding: 0 14%;
      .leftImg {
        width: 80%;
        height: 80%;
        object-fit: contain;
        margin: 3rem 0;
      }
      .rightInfo {
        padding: 3rem;
        .rightTitle {
          text-align: left;
          color: #777777;
          line-height: 3rem;
          font-size: 1.4rem;
          margin-bottom: 4rem;
        }
        .rightItem {
          display: flex;
          justify-content: flex-start;
          align-items: center;
            margin-bottom: 5rem;
          .itemImg {
            width: 1.6rem;
            margin-right: 1rem;
          }
          .itemTxt {
            font-size: 1.6rem;
            font-weight: bold;
            color: #666666;
          }
        }
      }
    }
  }
  .lastPart {
    padding: 5% 14%;
    .title2 {
      color: #333333;
      line-height: 5rem;
      font-size: 2.6rem;
      text-align: center;
    }
    .imgBox {
      .innerBox {
        position: relative;
        margin-top: 3rem;
        width: 100%;
        height: 33rem;
      }
    }
  }
  /deep/.el-dialog {
    background: none;
    box-shadow: none;
  }
  /deep/.el-dialog__body {
    height: 70vh;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  /deep/ .el-dialog__title {
    display: none;
  }
}
@import "../../../assets/responsive/perception.scss";
</style>
